import React from 'react';
import { connect } from '@cerebral/react';
import { signal, state } from 'cerebral/tags';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { appURL } from '../constants';
import { Loader } from '../components';
import theme from './SaveProgress.scss';

class SaveProgress extends React.Component {
    state = {
        email: '',
        emailSend: false,
        copied: false,
    };
    sendMail = (e) => {
        e.preventDefault();
        const { email } = this.state;
        const { emailId, trackEvent } = this.props;

        if (this.validate(email)) {
            emailId({ email });
        }

        trackEvent({
            eventAction: 'progress_saved_email',
        });
        this.setState({
            emailSend: true,
        });
    };
    validate = (email) => {
        const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return email && re.test(email.toLowerCase());
    };
    copied = () => {
        const { trackEvent } = this.props;
        trackEvent({
            eventAction: 'progress_saved_link',
        });
        this.setState({ copied: true });
    };
    handleMailChange = (e) => {
        const valid = this.validate(e.target.value);
        this.setState({
            email: e.target.value,
            valid,
        });
    };
    render() {
        const { emailLoading, error, id, answers } = this.props; // eslint-disable-line
        const { emailSend, valid, email } = this.state;

        if (Object.keys(answers).length === 0) {
            return null;
        }

        return (
            <div className={theme.SaveProgress}>
                <div className={theme.content} >
                    <h6 className={theme.Heading}>
                    Stuur jezelf een mailtje om alles
                    later&nbsp;verder&nbsp;af&nbsp;te&nbsp;werken:
                    </h6>
                    <p className={theme.Link}>
                        <CopyToClipboard
                            onCopy={this.copied}
                            text={`${appURL}?id=${id}`}
                        >
                            <button>
                            Of kopieer <span>deze unieke link</span>,
                            en sla hem op op een veilige plek.
                            </button>
                        </CopyToClipboard>
                        {this.state.copied && <p>Gekopieerd!</p>}
                    </p>
                </div>

                {emailLoading && <Loader />}
                {!emailLoading && (
                    <React.Fragment>
                        <form>
                            <div className="form-group">
                                <input
                                    type="email"
                                    className="form-control mr-2"
                                    id="inlineFormInput"
                                    onChange={this.handleMailChange}
                                    placeholder="naam@email.be"
                                    value={email}
                                />
                            </div>
                            <button
                                type="submit"
                                disabled={!valid}
                                className="btn btn-secondary"
                                onClick={this.sendMail}
                            >
                                {emailSend ? 'Verstuur opnieuw' : 'Verstuur'}
                            </button>
                        </form>
                    </React.Fragment>
                )}
                {error && (
                    <p>
                        Er ging iets mis bij het verzenden van de email, probeer
                        het later nog eens opnieuw
                    </p>
                )}

            </div>
        );
    }
}

const stateSignal = {
    trackEvent: signal`app.trackEvent`,
    emailId: signal`app.mailId`,
    emailLoading: state`app.mail.loading`,
    error: state`app.mail.error`,
    id: state`app.id`,
    answers: state`app.answers`,
};

export default connect(
    stateSignal,
    SaveProgress
);



// WEBPACK FOOTER //
// ./src/components/SaveProgress.js